import { Component, Input } from '@angular/core'
import { DdcCountryFlagComponent } from '../ddc-country-flag/ddc-country-flag.component'

@Component({
  selector: 'ddc-dual-lng',
  templateUrl: './ddc-dual-lng.component.html',
  styleUrl: './ddc-dual-lng.component.scss',
  imports: [DdcCountryFlagComponent],
})
export class DdcDualLngComponent {
  @Input('lng') _lng: any
  @Input('lng2') _lng2: any
  @Input('lng3') _lng3: any = null
}
